import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

export const publicServicesUrl = `${SERVER_API}/public/services`;

export const PUBLIC_SERVICES = {
  LIST: {
    method: 'GET',
    url: `${publicServicesUrl}`,
  } as IEndpointData,
  ABOUT(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${publicServicesUrl}/${id}/about`,
    };
  },
  SHOWCASE_GROUPS: {
    method: 'GET',
    url: `${publicServicesUrl}/showcase/groups`,
  } as IEndpointData,
  SHOWCASE_DEPARTMENTS: {
    method: 'GET',
    url: `${publicServicesUrl}/showcase/departments`,
  } as IEndpointData,
};
